


  
  

  var faEsg = {
    prefix: 'fak',
    iconName: 'esg',
    icon: [
      512,
      512,
      [],
      'e001',
      
      'M427.8 212.5c5.6-3.5 13-1.8 16.5 3.8l52.9 84.8c40 63.9-6 146.9-81.3 146.9H310.6l37.9 37.9c4.7 4.7 4.7 12.3 0 17l-5.7 5.7c-4.7 4.7-12.3 4.7-17 0l-68-68c-4.7-4.7-4.7-12.3 0-17l68-68c4.7-4.7 12.3-4.7 17 0l5.7 5.7c4.7 4.7 4.7 12.3 0 17L310.6 416H415.9c50.2 0 80.9-55.4 54.3-97.9l-53-84.8c-3.5-5.6-1.8-13 3.8-16.5l6.8-4.2zM104.8 171c6.5-1.5 12.9 2.5 14.4 9l21.6 93.7c1.5 6.5-2.5 12.9-9 14.4l-7.8 1.8c-6.5 1.5-12.9-2.5-14.4-9l-12-52.2L41.8 318.1C15.2 360.7 45.9 416 96.1 416H196c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H96.1c-75.3 0-121.3-83-81.4-146.9l55.8-89.4-52.2 12c-6.5 1.5-12.9-2.5-14.4-9L2.1 207c-1.5-6.5 2.5-12.9 9-14.4L104.8 171zm162.8 54.2c4.3 0 7.7 3.4 7.7 7.7v92.4c0 4.3-3.5 7.7-7.7 7.7H244.4c-4.3 0-7.7-3.4-7.7-7.7V232.9c0-4.3 3.5-7.7 7.7-7.7h23.1zm-61.7 46.2c4.3 0 7.7 3.4 7.7 7.7v46.2c0 4.3-3.5 7.7-7.7 7.7H182.7c-4.3 0-7.7-3.4-7.7-7.7V279.1c0-4.3 3.5-7.7 7.7-7.7h23.1zM329.3 179c4.3 0 7.7 3.4 7.7 7.7V325.3c0 4.3-3.5 7.7-7.7 7.7H306.1c-4.3 0-7.7-3.4-7.7-7.7V186.7c0-4.3 3.5-7.7 7.7-7.7h23.1zm8.1-133.9l46.2 74 12-52.1c1.5-6.5 7.9-10.5 14.4-9l7.8 1.8c6.5 1.5 10.5 7.9 9 14.4l-21.6 93.7c-1.5 6.5-7.9 10.5-14.4 9l-93.7-21.6c-6.5-1.5-10.5-7.9-9-14.4l1.8-7.8c1.5-6.5 7.9-10.5 14.4-9l52.2 12.1L310.3 62c-25-40-83.5-40.1-108.5 0l-43.4 69.5c-3.5 5.6-10.9 7.3-16.5 3.8l-6.8-4.2c-5.6-3.5-7.3-10.9-3.8-16.5l43.4-69.5C212.2-15 299.9-15 337.4 45.1z'
      
    ]
  };

  

  
  

  var faHashtagDecimal = {
    prefix: 'fak',
    iconName: 'hashtag-decimal',
    icon: [
      615,
      512,
      [],
      'e002',
      
      'M614.5 162.4l-1.6 9.1c-1.2 6.5-6.9 11.3-13.5 11.3l-117.6 0L455.6 329.1l112.7 0c8.5 0 15 7.7 13.5 16.1l-1.6 9.1c-1.2 6.5-6.9 11.3-13.5 11.3l-117.6 0L425 500.7c-1.2 6.5-6.9 11.3-13.5 11.3l-9.3 0c-8.5 0-15-7.7-13.5-16.1L412 365.7l-145.7 0-24.1 135c-1.2 6.5-6.9 11.3-13.5 11.3l-9.3 0c-8.5 0-15-7.7-13.5-16.1l23.2-130.2-112.7 0c-8.5 0-15-7.7-13.5-16.1l1.6-9.1c1.2-6.5 6.9-11.3 13.5-11.3l117.6 0 26.1-146.3-112.7 0c-8.5 0-15-7.7-13.5-16.1l1.6-9.1c1.2-6.5 6.9-11.3 13.5-11.3l117.6 0 24.1-135C293.6 4.8 299.2 0 305.9 0l9.3 0c8.5 0 15 7.7 13.5 16.1L305.4 146.3l145.7 0 24.1-135C476.4 4.8 482.1 0 488.7 0L498 0c8.5 0 15 7.7 13.5 16.1L488.3 146.3l112.7 0c8.5 0 15 7.7 13.5 16.1zM272.8 329.1l145.7 0 26.1-146.3-145.7 0L272.8 329.1zM102.7 460.8A51.2 51.2 0 1 1 .3 460.8a51.2 51.2 0 1 1 102.4 0z'
      
    ]
  };

  

  
  

  var faTapeCracker = {
    prefix: 'fak',
    iconName: 'tape-cracker',
    icon: [
      615,
      512,
      [],
      'e000',
      
      'M557.1 46.8c31.8 0 57.6 23.4 57.6 52.3V412.9c0 28.9-25.8 52.3-57.6 52.3H57.9c-31.8 0-57.6-23.4-57.6-52.3V99.1c0-28.9 25.8-52.3 57.6-52.3H557.1zm0 34.9l-233 0-8.4 25.5h31c5 0 8.1 5.4 5.6 9.7L305 198.3c-1.2 2-3.3 3.2-5.6 3.2c-4.1 0-7.2-3.8-6.3-7.9l12.4-52.1H273.7c-3.9 0-6.9-3.4-6.4-7.3l7-52.5-216.3 0C48.5 81.7 40.6 87.9 39 96l-.3 3.1V412.9c0 9.6 8.6 17.4 19.2 17.4H557.1c10.6 0 19.2-7.8 19.2-17.4V99.1c0-9.6-8.6-17.4-19.2-17.4zm-142 87.1c48.2 0 87.4 39.3 87.4 87.7c0 48.3-39.2 87.7-87.4 87.7H199.9c-48.2 0-87.4-39.3-87.4-87.7c0-48.4 39.2-87.7 87.4-87.7s87.4 39.4 87.4 87.7c0 23.5-9.3 44.7-24.3 60.5h88.8c-15-15.7-24.3-37-24.3-60.5c0-48.4 39.2-87.7 87.4-87.7zM199.9 196a60.5 60.5 0 1 0 0 121 60.5 60.5 0 1 0 0-121zm215.1 0a60.5 60.5 0 1 0 0 121 60.5 60.5 0 1 0 0-121z'
      
    ]
  };

  



export {

  faEsg,
  

  faHashtagDecimal,
  

  faTapeCracker,
  

};
